var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1428 14C19.1428 16.8404 16.8403 19.1429 14 19.1429C11.1596 19.1429 8.85709 16.8404 8.85709 14C8.85709 11.1597 11.1596 8.85717 14 8.85717C16.8403 8.85717 19.1428 11.1597 19.1428 14ZM19.1428 14V15.7143C19.1428 17.6079 20.6779 19.1428 22.5715 19.1428C23.7877 19.1428 24.8563 18.5095 25.4648 17.5544C25.8037 17.0228 26 16.3915 26 15.7143V14C26 10.446 24.4549 7.25285 22 5.05557M14 2C7.37259 2 2 7.37259 2 14C2 20.6275 7.37259 26 14 26C16.5496 26 18.9135 25.2049 20.8572 23.8491",
    stroke: "#4540DB",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsIcon);
export default __webpack_public_path__ + "static/media/aboutUsIcon.75d16bb037557027a9acb6eb94825afa.svg";
export { ForwardRef as ReactComponent };